module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.9 0 0 .9 0 2v28c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM4 4h4v4H4V4zm24 4H12V4h16v4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/browser-1.js
// module id = 1025
// module chunks = 14